import * as R from "ramda";
import { Action } from "redux";
import { AppState } from "./appState";
import ACTION_TYPE from "./ActionTypes";
import { IFilterForm } from "./overagesFilterFormActions";

export type typeExceptionSearchFilterForm = {
  type: ACTION_TYPE.EXCEPTION_SEARCH_FILTER_FORM_STATE;
  exceptionSearchFilterForm: IFilterForm;
};

/**
 * Redux action to update DispatchForm in Redux State
 * @param exceptionFilterForm - the params we use for the dispatch api put request Obtained from DispatchForm component.
 */

export const saveExceptionSearchFilterForm = (
    exceptionSearchFilterForm: IFilterForm
): typeExceptionSearchFilterForm => ({
  type: ACTION_TYPE.EXCEPTION_SEARCH_FILTER_FORM_STATE,
  exceptionSearchFilterForm: exceptionSearchFilterForm,
});

export const saveExceptionSearchFilterFormReducer = (
  state: AppState,
  action: Action
): AppState => {
  if (action.type !== ACTION_TYPE.EXCEPTION_SEARCH_FILTER_FORM_STATE) {
    return state;
  }
  return R.mergeRight(state, {
    exceptionSearchFilterForm: (action as typeExceptionSearchFilterForm)
      .exceptionSearchFilterForm,
  });
};
